import { DeFiDevelopmentPage } from './DeFiDevelopmentPage';

export default DeFiDevelopmentPage;
